<template>
  <v-form :submit="submitUpdate">
    <v-row>
      <v-col cols="6">
        <v-text-field
                      label="Código Referência"
                      v-model="value.ref"
                      hide-details
                      density="compact"></v-text-field>
      </v-col>
      <v-col cols="6">
        <AutocompleteSelectCashflowCategory v-if="adminGroup != null"
                                            :user="user"
                                            v-model="value.cashflow_category"
                                            :groupId="adminGroup.id"
                                            :returnObject="true"
                                            :multiple="false"
                                            :rules="rules.required"
                                            label="Rubrica (categoria)"
                                            density="compact"
                                            :types="[
                                              $CASH_FLOW_CATEGORY_TYPES_DIC['IN'].value,
                                              $CASH_FLOW_CATEGORY_TYPES_DIC['BOTH'].value,
                                            ]" />
      </v-col>
      <v-col cols="12">
        <AutocompleteSelectCreateLegalPerson
                                             :user="user"
                                             label="Grupo destino"
                                             :customTypes="[13]"
                                             v-model="value.legal_person_to"
                                             :multiple="true"
                                             density="compact" />
      </v-col>
      <v-col cols="4">
        <v-text-field
                      label="Valor R$"
                      v-model="value.amount"
                      type="number"
                      :rules="rules.required"
                      hide-details
                      density="compact"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
                      label="Desconto R$"
                      v-model="value.early_payment_discount"
                      clearable
                      type="number"
                      hide-details
                      density="compact"></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
                      label="Data de vencimento"
                      :value="$moment(value.due_date?.substring(0, 10)).format('YYYY-MM-DD')"
                      :model-value="$moment(value.due_date?.substring(0, 10)).format('YYYY-MM-DD')"
                      @input="dueDateChanged"
                      type="date"
                      :rules="rules.required"
                      hide-details
                      density="compact"></v-text-field>
      </v-col>
      <v-col cols="6" v-if="modelValue.id == null">
        <v-text-field
                      label="Parcelas"
                      v-model="value.quantity"
                      type="number"
                      :rules="rules.required"
                      hide-details
                      density="compact"></v-text-field>
      </v-col>
      <v-col cols="6" v-if="modelValue.id == null">
        <AutocompleteSpecialFilters
                                    v-model="value.interval"
                                    :lstObjects="$SPECIAL_FILTERS_NEW_INVOICE_INTERVALS"
                                    :multiple="false"
                                    label="Intervalo"
                                    density="compact" />
      </v-col>
      <v-col cols="12">
        <v-text-field
                      label="Descrição"
                      v-model="value.description"
                      hide-details
                      density="compact"></v-text-field>
      </v-col>
      <v-col cols="12" class="text-right">
        <v-btn color="success" type="submit" density="compact">
          <v-icon class="mr-2">mdi-content-save</v-icon>
          Salvar
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import AutocompleteSelectCashflowCategory from "./AutocompleteSelectCashflowCategory.vue";
import AutocompleteSelectCreateLegalPerson from "./AutocompleteSelectCreateLegalPerson.vue";
import AutocompleteSpecialFilters from "./AutocompleteSpecialFilters.vue";
import api from '@/services'
export default {
  components: {
    AutocompleteSelectCreateLegalPerson,
    AutocompleteSelectCashflowCategory,
    AutocompleteSpecialFilters,
  },
  props: {
    user: Object,
    modelValue: Object,
  },
  emits: ["update:modelValue", "created", "updated", "writeoff"],
  data() {
    return {
      requestingApi: null,
      adminGroup: null,
      rules: {
        required: [(v) => !!v || "Campo obrigatório"],
        required0: [(v) => (v == null || v != 0 && !!v || v < 0) || "Campo obrigatório e deve ser maior que zero"],
      },
    };
  },
  created() {
    const vm = this;

    vm.requestingApi = true;
    api.group
      .get(777)
      .then((result) => {
        vm.adminGroup = result;
      })
      .catch((err) => {
        if (err.message) {
          vm.$notify({
            type: "warn",
            text: err.message,
          });
        }
      })
      .finally(() => {
        vm.requestingApi = false;
      });
  },
  mounted() {
    var vm = this;

    if (!vm.modelValue?.id) {
      vm.value = vm.generateEmpty();
    } else {
      vm.value.legal_person_from = vm.adminGroup.legal_person;
    }
  },
  methods: {
    dueDateChanged(event) {
      const vm = this;

      if (event?.target?.value?.length === 10) {
        vm.value.due_date = event.target.value;
      }
    },
    submitUpdate() {
      var vm = this;

      if (!vm?.modelValue?.due_date) {
        vm.$notify({
          type: "warn",
          text: "Selecione a data de vencimento!",
        });
        return;
      }

      if (!vm?.modelValue?.cashflow_category) {
        vm.$notify({
          type: "warn",
          text: "Selecione a Rubrica!",
        });
        return;
      }
      if (vm.modelValue.quantity > 1 && !vm.modelValue.interval) {
        vm.$notify({
          type: "warn",
          text: "Para gerar mais de uma é necessário informar um intervalo!",
        });
        return;
      }

      if ((!vm.modelValue.legal_person_to || vm.modelValue.legal_person_to.length === 0) && !vm.modelValue.special_filter) {
        vm.$notify({
          type: "warn",
          text: "Selecione pelo menos um filtro de destino",
        });
        return;
      }
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        const method = vm.modelValue?.id ? 'update' : 'create';
        const data = {
          ...vm.value,
          legal_person_from: vm.adminGroup?.legal_person,
          selected_group_id: 777,
          type: vm.$INVOICE_TYPE_DIC.SERVICE.value
        };

        console.log(method, data);
        api.invoice[method](data)
          .then((result) => {
            console.log(vm.modelValue, result);
            if (vm.modelValue?.id) {
              vm.$emit("updated", result);
            } else {
              vm.$emit("created", result);
            }
            vm.$notify({
              type: "success",
              text: "Dados alterados com sucesso",
            });
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    generateEmpty() {
      const vm = this;

      return {
        legal_person_to: [],
        legal_person_from: vm.adminGroup?.legal_person,
        amount: null,
        early_payment_discount: null,
        ref: null,
        description: null,
        notes: null,
        due_date: vm.$moment(new Date()).format('YYYY-MM-DD'),
        quantity: 1,
        interval: null,
        special_filters: [],
        cashflow_category: null,
        type: vm.$INVOICE_TYPE_DIC.SERVICE.value
      };
    }
  },
  computed: {
    hasAdminAccess() {
      return this.user.access_level >= this.$USER_ACCESS_LEVELS_DIC.GROUP_ADMIN.value;
    },
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {},
};
</script>